
export const AllFunctionMapping = [
    { KCode: "K50", keyCode: '0', hid: 0xB4, value: 'Left Click', translate: 'Left Click' },
    { KCode: "K51", keyCode: '2', hid: 0xB5, value: 'Right Click', translate: 'Right Click' },
    { KCode: "K52", keyCode: '1', hid: 0xB6, value: 'Scroll Click', translate: 'Scroll Click' },
    { KCode: "K53", keyCode: '3', hid: 0xB7, value: 'Back', translate: 'Back' },
    { KCode: "K54", keyCode: '4', hid: 0xB8, value: 'Forward', translate: 'Forward' },
    { KCode: "K153", keyCode: '65', value: 'A', hid: 0x4, translate: 'A' },
    { KCode: "K170", keyCode: '66', value: 'B', hid: 0x5, translate: 'B' },
    { KCode: "K168", keyCode: '67', value: 'C', hid: 0x6, translate: 'C' },
    { KCode: "K155", keyCode: '68', value: 'D', hid: 0x7, translate: 'D' },
    { KCode: "K138", keyCode: '69', value: 'E', hid: 0x8, translate: 'E' },
    { KCode: "K156", keyCode: '70', value: 'F', hid: 0x9, translate: 'F' },
    { KCode: "K157", keyCode: '71', value: 'G', hid: 0xa, translate: 'G' },
    { KCode: "K158", keyCode: '72', value: 'H', hid: 0xb, translate: 'H' },
    { KCode: "K143", keyCode: '73', value: 'I', hid: 0xc, translate: 'I' },
    { KCode: "K159", keyCode: '74', value: 'J', hid: 0xd, translate: 'J' },
    { KCode: "K160", keyCode: '75', value: 'K', hid: 0xe, translate: 'K' },
    { KCode: "K161", keyCode: '76', value: 'L', hid: 0xf, translate: 'L' },
    { KCode: "K172", keyCode: '77', value: 'M', hid: 0x10, translate: 'M' },
    { KCode: "K171", keyCode: '78', value: 'N', hid: 0x11, translate: 'N' },
    { KCode: "K144", keyCode: '79', value: 'O', hid: 0x12, translate: 'O' },
    { KCode: "K145", keyCode: '80', value: 'P', hid: 0x13, translate: 'P' },
    { KCode: 'K136', keyCode: '81', value: 'Q', hid: 0x14, translate: 'Q' },
    { KCode: 'K139', keyCode: '82', value: 'R', hid: 0x15, translate: 'R' },
    { KCode: 'K154', keyCode: '83', value: 'S', hid: 0x16, translate: 'S' },
    { KCode: 'K140', keyCode: '84', value: 'T', hid: 0x17, translate: 'T' },
    { KCode: 'K142', keyCode: '85', value: 'U', hid: 0x18, translate: 'U' },
    { KCode: 'K169', keyCode: '86', value: 'V', hid: 0x19, translate: 'V' },
    { KCode: 'K137', keyCode: '87', value: 'W', hid: 0x1a, translate: 'W' },
    { KCode: 'K167', keyCode: '88', value: 'X', hid: 0x1b, translate: 'X' },
    { KCode: 'K141', keyCode: '89', value: 'Y', hid: 0x1c, translate: 'Y' },
    { KCode: 'K166', keyCode: '90', value: 'Z', hid: 0x1d, translate: 'Z' },
    { KCode: "K128", keyCode: '48', value: '0', hid: 0x27, translate: '0' },
    { KCode: "K119", keyCode: '49', value: '1', hid: 0x1e, translate: '1' },
    { KCode: "K120", keyCode: '50', value: '2', hid: 0x1f, translate: '2' },
    { KCode: "K121", keyCode: '51', value: '3', hid: 0x20, translate: '3' },
    { KCode: "K122", keyCode: '52', value: '4', hid: 0x21, translate: '4' },
    { KCode: "K123", keyCode: '53', value: '5', hid: 0x22, translate: '5' },
    { KCode: "K124", keyCode: '54', value: '6', hid: 0x23, translate: '6' },
    { KCode: "K125", keyCode: '55', value: '7', hid: 0x24, translate: '7' },
    { KCode: "K126", keyCode: '56', value: '8', hid: 0x25, translate: '8' },
    { KCode: "K127", keyCode: '57', value: '9', hid: 0x26, translate: '9' },
    { KCode: 'K131', keyCode: '8', value: 'Backspace', hid: 0x2a, translate: 'Backspace' },
    { KCode: 'K135', keyCode: '9', value: 'Tab', hid: 0x2b, translate: 'Tab' },
    { KCode: "K164", keyCode: '13', value: 'Enter', hid: 0x28, translate: 'Enter' },
    { KCode: 'K117' ,keyCode: '19', value: 'Break', hid: 0x48, translate: 'Break' },
    { KCode: 'K152', keyCode: '20', value: 'CapsLock', hid: 0x39, translate: 'CapsLock' },
    { KCode: 'K11' , keyCode: '27', value: 'Esc', hid: 0x29, translate: 'Esc' },
    { KCode: 'K181', keyCode: '32', value: 'Space', hid: 0x2c, translate: 'Space' },
    { KCode: 'K134' ,keyCode: '33', value: 'PageUp', hid: 0x4b, translate: 'PageUp' },
    { KCode: 'K151' ,keyCode: '34', value: 'PageDown', hid: 0x4e, translate: 'PageDown' },
    { KCode: 'K150' ,keyCode: '35', value: 'End', hid: 0x4d, translate: 'End' },
    { KCode: 'K133' ,keyCode: '36', value: 'Home', hid: 0x4a, translate: 'Home' },
    { KCode: 'K186' ,keyCode: '37', value: 'Left', hid: 0x50, translate: 'Left' },
    { KCode: 'K177' ,keyCode: '38', value: 'Up', hid: 0x52, translate: 'Up' },
    { KCode: 'K188' ,keyCode: '39', value: 'Right', hid: 0x4f, translate: 'Right' },
    { KCode: 'K187' ,keyCode: '40', value: 'Down', hid: 0x51, translate: 'Down' },
    { KCode: 'K115' , keyCode: '42', value: 'PRINT SCREEN', hid: 0x46, translate: 'PRINT SCREEN' },
    { KCode: 'K132' ,keyCode: '45', value: 'Insert', hid: 0x49, translate: 'Insert' },
    { KCode: 'K149' ,keyCode: '46', value: 'Delete', hid: 0x4c, translate: 'Delete' },
    { KCode: 'K179' , keyCode: '91', value: 'Left Win', hid: 0xe3, translate: 'Left Win' },
    { KCode: 'K183' ,keyCode: '92', value: 'Right Win', hid: 0xe7, translate: 'Right Win' },
    { KCode: 'K179' ,keyCode: '91', value: 'Win', hid: 0xe3, translate: 'Win' },
    
    { KCode: 'K165', keyCode: '16', value: 'Shift', hid: 0xe1, translate: 'Shift' },//LShift
    { KCode: 'K178' ,keyCode: '17', value: 'Ctrl', hid: 0xe0, translate: 'Ctrl' },//LCtrl
    { KCode: 'K180' ,keyCode: '18', value: 'Alt', hid: 0xe2, translate: 'Alt' },//LAlt
    { KCode: 'K176', keyCode: '16', value: 'RShift', hid: 0xe5, translate: 'RShift' },//LShift
    { KCode: 'K185' ,keyCode: '17', value: 'RCtrl', hid: 0xe4, translate: 'RCtrl' },//LCtrl
    { KCode: 'K182' ,keyCode: '18', value: 'RAlt', hid: 0xe6, translate: 'RAlt' },//LAlt
    
    { KCode: 'K184' ,keyCode: '93', value: 'Menu', hid: 0x65, translate: 'Menu' },
    { KCode: 'K13' , keyCode: '112', value: 'F1', hid: 0x3a, translate: 'F1' },
    { KCode: 'K14' , keyCode: '113', value: 'F2', hid: 0x3b, translate: 'F2' },
    { KCode: 'K15' , keyCode: '114', value: 'F3', hid: 0x3c, translate: 'F3' },
    { KCode: 'K16' , keyCode: '115', value: 'F4', hid: 0x3d, translate: 'F4' },
    { KCode: 'K17' , keyCode: '116', value: 'F5', hid: 0x3e, translate: 'F5' },
    { KCode: 'K18' , keyCode: '117', value: 'F6', hid: 0x3f, translate: 'F6' },
    { KCode: 'K19' , keyCode: '118', value: 'F7', hid: 0x40, translate: 'F7' },
    { KCode: 'K110', keyCode: '119', value: 'F8', hid: 0x41, translate: 'F8' },
    { KCode: 'K111', keyCode: '120', value: 'F9', hid: 0x42, translate: 'F9' },
    { KCode: 'K112', keyCode: '121', value: 'F10', hid: 0x43, translate: 'F10' },
    { KCode: 'K113', keyCode: '122', value: 'F11', hid: 0x44, translate: 'F11' },
    { KCode: 'K114', keyCode: '123', value: 'F12', hid: 0x45, translate: 'F12' },
    { KCode: 'K116' ,keyCode: '145', value: 'Scroll Lock', hid: 0x47, translate: 'Scroll Lock' },
    { KCode: 'K162', keyCode: '186', value: ';', hid: 0x33, translate: ';' },
    { KCode: 'K130', keyCode: '187', value: '=', hid: 0x2e, translate: '=' },
    { KCode: 'K173', keyCode: '188', value: ',', hid: 0x36, translate: ',' },
    { KCode: 'K129', keyCode: '189', value: '-', hid: 0x2d, translate: '-' },
    { KCode: 'K174',keyCode: '190', value: 'dot', hid: 0x37, translate: 'dot' },
    { KCode: 'K175',keyCode: '191', value: '/', hid: 0x38, translate: '/' },
    { KCode: 'K118',keyCode: '192', value: '~', hid: 0x35, translate: '~' },
    { KCode: 'K146',keyCode: '219', value: '[', hid: 0x2f, translate: '[' },
    { KCode: ''    ,keyCode: '220', value: '|', hid: 0x31, translate: '|' },//K45
    { KCode: 'K147',keyCode: '221', value: ']', hid: 0x30, translate: ']' },
    { KCode: 'K163',keyCode: '222', value: "'", hid: 0x34, translate: "'" },

    { KCode: 'K148',keyCode: '191', value: '\\', hid: 0x31, translate: '\\' },
    
    { KCode: 'K21' , keyCode: '144', value: 'Num Lock', hid: 0x53, translate: 'Num Lock' },
    { KCode: 'K211' ,keyCode: '97', value: 'Num 1', hid: 0x59, translate: 'Num 1' },
    { KCode: 'K212' ,keyCode: '98', value: 'Num 2', hid: 0x5a, translate: 'Num 2' },
    { KCode: 'K213' ,keyCode: '99', value: 'Num 3', hid: 0x5b, translate: 'Num 3' },
    { KCode: 'K29'  ,keyCode: '100', value: 'Num 4', hid: 0x5c, translate: 'Num 4' },
    { KCode: 'K218' ,keyCode: '101', value: 'Num 5', hid: 0x5d, translate: 'Num 5' },
    { KCode: 'K210' ,keyCode: '102', value: 'Num 6', hid: 0x5e, translate: 'Num 6' },
    { KCode: 'K25'  ,keyCode: '103', value: 'Num 7', hid: 0x5f, translate: 'Num 7' },
    { KCode: 'K26'  ,keyCode: '104', value: 'Num 8', hid: 0x60, translate: 'Num 8' },
    { KCode: 'K27'  ,keyCode: '105', value: 'Num 9', hid: 0x61, translate: 'Num 9' },
    { KCode: 'K22'  ,keyCode: '111', value: '(/)', hid: 0x54, translate: '(/)' },
    { KCode: 'K23'  ,keyCode: '106', value: '(*)', hid: 0x55, translate: '(*)' },
    { KCode: 'K24'  ,keyCode: '109', value: '(-)', hid: 0x56, translate: '(-)' },
    { KCode: 'K28'  ,keyCode: '107', value: '(+)', hid: 0x57, translate: '(+)' },
    { KCode: 'K217'  ,keyCode: '', value: 'Num Enter', hid: 0x58, translate: 'Num Enter' },
    { KCode: 'K215' ,keyCode: '96', value: 'Num 0', hid: 0x62, translate: 'Num 0' },
    { KCode: 'K216' ,keyCode: '110', value: 'Numdot', hid: 0x63, translate: 'Numdot' },
    //Media
    { KCode: 'K31'  ,keyCode: '', value: '', hid: 0XA0, translate: '媒體播放器' },
    { KCode: 'K32'  ,keyCode: '', value: '', hid: 0XA1, translate: '播放/暫停' },
    { KCode: 'K33'  ,keyCode: '', value: '', hid: 0XA5, translate: '停止' },
    { KCode: 'K34'  ,keyCode: '', value: '', hid: 0XA6, translate: '上一曲' },
    { KCode: 'K35'  ,keyCode: '', value: '', hid: 0XA7, translate: '下一曲' },
    { KCode: 'K36'  ,keyCode: '', value: '', hid: 0XA3, translate: '音量加' },
    { KCode: 'K37'  ,keyCode: '', value: '', hid: 0XA4, translate: '音量減' },
    { KCode: 'K38'  ,keyCode: '', value: '', hid: 0XA2, translate: '靜音' },
    //Browser
    { KCode: 'K41'  ,keyCode: '', value: '', hid: 0XAB, translate: 'PAGEBACK' },
    { KCode: 'K42'  ,keyCode: '', value: '', hid: 0XAC, translate: 'PAGEFORWARD' },
    { KCode: 'K43'  ,keyCode: '', value: '', hid: 0XA9, translate: 'REFRESHPAGE' },
    { KCode: 'K44'  ,keyCode: '', value: '', hid: 0XAD, translate: 'BROWSERCOLLECT' },
    { KCode: 'K45'  ,keyCode: '', value: '', hid: 0XA8, translate: 'HOMEPAGE' },
    { KCode: 'K46'  ,keyCode: '', value: '', hid: 0XB1, translate: 'EMAIL' },
    { KCode: 'K47'  ,keyCode: '', value: '', hid: 0XAF, translate: 'MYCOMPUTER' },
    { KCode: 'K48'  ,keyCode: '', value: '', hid: 0XD7, translate: 'PASTE' },
    { KCode: 'K49'  ,keyCode: '', value: '', hid: 0XD6, translate: 'COPY' },

    //Profile Switch
    { KCode: 'K71'  ,keyCode: '', value: '', hid: 0XB2, translate: '硬體配置+' },
    { KCode: 'K72'  ,keyCode: '', value: '', hid: 0XB3, translate: '硬體配置-' },

    { KCode: 'K189'  ,keyCode: '', value: '', hid: 0XFE, translate: 'FN' },    
]




